@import "~/styles/v1/_variables.scss";

$CIRCLE_DIAMETER_DEFAULT: 30px;
$CIRCLE_DIAMETER_LARGE: 45px;

.UserCircleImage {
  background: $system_white-base;
  border-radius: $border-radius-large;
  overflow: hidden;
  display: block;
  position: relative;
  img {
    width: 100%;
  }
  &.default {
    width: 50px;
    height: 50px;
    min-width: 50px;
  }
  &.small {
    width: 30px;
    height: 30px;
    min-width: 30px;
  }
  &.extra-small {
    width: 20px;
    height: 20px;
    min-width: 20px;
  }
  &.uploadIcon {
    .UserCircleImage-empty {
      background-size: 20px;
    }
  }
}
.UserCircleImage-empty {
  background: $system_white-base;
  background-size: 100% 100%;
  position: relative;
  font-size: 11px;
  text-transform: uppercase;
  width: 100%;
  padding-bottom: 100%;
  text-align: center;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  .UserCircleImage-empty-initials {
    opacity: 0.7;
    position: absolute;
    top: 50%;
    width: 100%;
    left: 0;
    text-align: center;
    margin-top: -7px;
  }
}
.UserCircleImage-imageSquare {
  width: 100%;
  padding-bottom: 100%;
  background-size: cover;
  background-position: center center;
  position: relative;
  display: flex;
}
.UserCircleImage-background {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
}

.UserCircleImage-colourStripe {
  flex: 1;
}
